import { inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as actions from '../actions/museum-collections.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { MuseumCollectionsService } from '../../services';
import { Go } from 'src/app/store';

export const LoadMuseumCollections$ = createEffect(
  (actions$ = inject(Actions), service = inject(MuseumCollectionsService)) => {
    return actions$.pipe(
      ofType(actions.LoadMuseumCollections),
      switchMap(() =>
        service.getCollections().pipe(
          map(collections => actions.LoadMuseumCollectionsSuccess({ collections })),
          catchError(error => of(actions.LoadMuseumCollectionsFail({ error })))
        )
      )
    );
  },
  { functional: true }
);

export const LoadById$ = createEffect(
  (actions$ = inject(Actions), service = inject(MuseumCollectionsService)) => {
    return actions$.pipe(
      ofType(actions.LoadMuseumCollectionById),
      switchMap(({ id }) =>
        service.getCollectionById(id).pipe(
          map(collection => actions.LoadMuseumCollectionByIdSuccess({ collection })),
          catchError(error => of(actions.LoadMuseumCollectionByIdFail({ id, error })))
        )
      )
    );
  },
  { functional: true }
);

export const LoadByIdFail$ = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(actions.LoadMuseumCollectionByIdFail),
      map(({ error }) => {
        return Go({ path: ['/' + error?.status ? error.status : '404'], extras: { skipLocationChange: true } });
      })
    );
  },
  { functional: true }
);
